<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper attendance-page">
    <div class="content container-fluid">
      <!-- Page Header -->
      <breadcrumb-header :title="title" :path="path" :text="text" />
      <!-- /Page Header -->

      <!-- Search Filter -->
      <attendance-filter @attFilterClicked="searchClicked"></attendance-filter>
      <!-- /Search Filter -->

      <div class="row">
        <div class="col-lg-12">
          <!-- Show Entries - Above Table -->
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2">
              <span>Show</span>
              <select v-model="perPage" @change="attendance" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped custom-table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th v-for="(day, index) in days" :key="index"><span class="ms-1">{{ day }}</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in userAttendance" :key="item.id">
                  <td>
                    <h2 class="table-avatar">
                      <!--                        <router-link class="avatar avatar-xs" to="/profile/employee-profile"-->
                      <!--                          ><img-->
                      <!--                            :src="require(`@/assets/img/profiles/${item.Image}`)"-->
                      <!--                            alt="User Image"-->
                      <!--                        /></router-link>-->
                      <!-- <router-link :to="`/profile/employee-profile/${item.id}`">{{ item.name }}</router-link> -->

                      <!-- <router-link class="dropdown-item"
                        :to="{ path: '/employee/attendance-employee', query: { id: item.id } }"></router-link> -->
                      <action-dropdown @banked-time="bankedTimeClicked"
                        variant="text"
                        :employee="item"
                        :reportAsEvent="true"
                        @edit="editClicked"
                        @leaves="leavesClicked"
                        @attendance="attendanceClicked"
                        @sick-leave="sickLeaveClicked"
                        @toggle-monitoring="monitorClicked"
                        @add-face-template="addFaceTemplateClicked"
                        @face-templates="faceTemplatesClicked"
                        @report="viewReport"
                        @reset-password="resetPasswordClicked"
                        @assign-employee="assignEmployeeClicked"
                      />

                    </h2>
                  </td>
                  <td v-for="(day, index) in days" :key="index">
                    <!-- <a
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#attendance_info"
                        @click="open(item)"
                        > -->
                    <i :class="this.isUserPresent(item.id, day)"></i>

                    <!-- </a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination - Below Table, Centered -->
          <div class="d-flex justify-content-center mt-3">
            <a-pagination 
              v-model:current="currentPage" 
              v-model:pageSize="perPage" 
              :total="total" 
              @change="attendance"
              show-less-items 
              :showSizeChanger="false">
              <template #itemRender="{ type, originalElement }">
                <a v-if="type === 'prev'">Previous</a>
                <a v-else-if="type === 'next'">Next</a>
                <component :is="originalElement" v-else></component>
              </template>
            </a-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <attendance-modal ref="userAttendance"></attendance-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUsers"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="attendance"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
  </div>
  <!-- Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
// import Attendance from "@/assets/json/attendance.json";
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatYYYYMMDD, noOfDaysInMonth } from "@/utils/util-funcitons";
import { dateRangeStart, dateRangeEnd } from '@/utils/util-var';
import ActionDropdown from "@/components/action-dropdown.vue";
import { monitorMixin } from "@/mixins/monitorMixin";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import { Modal } from "bootstrap";

export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    return {
      title: "Attendance",
      path: "Dashboard",
      text: "Attendance",
      days: null,
      userAttendance: null,
      attendanceKeys: null,
      month: (new Date()).toLocaleString('default', { month: 'long' }),
      year: (new Date).getFullYear(),
      employeeName: null,
      currentPage: 1,
      perPage: 25,
      total: 0,
      startDate: dateRangeStart,
      endDate: dateRangeEnd
    };
  },
  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    // getEmployee(){
    //   return axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/list`);
    // },
    // getAttendance(){
    //   return axios.get(`${process.env.VUE_APP_API_BASE_URL}/attendance/all`);
    // },
    open(item) {
      this.$refs.userAttendance.openUserAttendance(item);
    },

    daysInMonth(monthNum, yearNum) {
      const year = yearNum || (new Date()).getFullYear();
      const month = monthNum || (new Date()).getMonth() + 1;
      return new Date(year, month, 0).getDate();
    },

    async attendance() {
      const instance = this;

      // Promise.all([this.getAttendance(), this.getEmployee()])
      if (Number(this.perPage) >= this.total) {
        this.currentPage = 1;
      }
      await axios.get(`${VUE_APP_API_BASE_URL}/attendance/all`, {
        params: {
          month: this.month,
          year: this.year,
          employee_name: this.employeeName,
          page: this.currentPage,
          per_page: this.perPage,
        }
      })
        .then((attendance) => {
          if (attendance.data.status) {
            let attendanceKeys = [];
            // Handle paginated response
            const responseData = attendance.data.data.data || attendance.data.data;
            instance.userAttendance = responseData;
            instance.userAttendance.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
            // Update pagination info if available
            if (attendance.data.data.current_page) {
              instance.currentPage = attendance.data.data.current_page;
              instance.total = attendance.data.data.total;
            }
            for (let att of responseData) {
              let userId = att.id;
              let userAttendanceKeys = att.user_attendances;
              for (let useratt of userAttendanceKeys) {
                attendanceKeys.push(userId + useratt.record_date);
              }
            }
            instance.attendanceKeys = attendanceKeys;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    formatDayToYYYYMMDD(year, month, day) {
      if (typeof month === 'string') {
        const months = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];

        month = months.indexOf(month) + 1; // +1 because indexOf returns 0-based
      }
      month = '' + month;
      day = '' + day;

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return `${year}-${month}-${day}`;
    },

    isUserPresent(userId, day) {
      let date = this.formatDayToYYYYMMDD(this.year, this.month, day);
      let id = userId + date;
      return (this.attendanceKeys.includes(id)) ? "fa-solid fa-check text-success" : "fa fa-close text-danger";
    },
    searchClicked(data) {
      this.month = data.month;
      this.year = data.year;
      this.employeeName = data.employee_name;
      this.days = this.daysInMonth(this.month, this.year);
      this.attendance();
    },
    daysTillNow() {
      let days = [];
      for (let i = 1; i <= (new Date()).getDate(); i++) {
        days.push(i);
      }
      return days;
    },
    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },


    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },

    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },
  },
  mounted() {
    this.days = noOfDaysInMonth();
    this.attendance();
  }
};
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

table>tbody>tr>td:first-child {
  position: sticky;
  left: 0;
  min-width: 200px;
  width: auto;
  white-space: nowrap;
  background-color: #FFF;
  opacity: 1;
  text-align: left;
  font-weight: bold;
  z-index: 1;
}

/* Update the sticky cell with open dropdown to have higher z-index than segments and header */
table > tbody > tr > td:first-child:has(.dropdown-menu.show) {
  z-index: 30 !important;
}

/* Ensure the row also has higher stacking context when dropdown is open */
table > tbody > tr:has(.dropdown-menu.show) {
  position: relative;
  z-index: 30;
}

table>thead>tr>th:first-child,
table>tbody>tr>th:first-child {
  position: sticky;
  left: 0;
  min-width: 200px;
  width: auto;
  white-space: nowrap;
  background-color: #FFF;
  opacity: 1;
  text-align: left;
  font-weight: bold;
  z-index: 20;
}

table>thead>tr>td:nth-child(2),
table>tbody>tr>td:nth-child(2) {
  padding-left: 10px !important;
}

table>thead>tr>th:nth-child(2),
table>tbody>tr>th:nth-child(2) {
  padding-left: 10px !important;
}

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}
</style>

<!-- Unscoped: :has() needs to match .dropdown-menu inside child ActionDropdown component -->
<style>
.attendance-page .table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}

/* When a dropdown is open, raise tbody above thead so the menu isn't hidden behind the sticky header */
.attendance-page .table-responsive:has(.dropdown-menu.show) tbody {
  position: relative;
  z-index: 21; /* Must be higher than th:first-child z-index (20) */
}

.attendance-page .table-responsive:has(.dropdown-menu.show) thead {
  position: relative;
  z-index: 1;
}
</style>
